<ng-container *ngIf="filterList$ | async as filterList">
  <mat-menu #customFilterMenu="matMenu">
    <span mat-menu-item *ngIf="isLoading">Konfigurationen werden geladen...</span>
    <button
      [disabled]="isLoading"
      *ngFor="let filterItem of filterList"
      mat-menu-item
      [matMenuTriggerFor]="customFilterActionMenu"
      [matMenuTriggerData]="{ filterItem: filterItem, filterList: filterList }">
      <mat-icon>wand_stars</mat-icon>
      <span>{{ filterItem.name }}</span>
    </button>
    <button [disabled]="isLoading" mat-menu-item (click)="openNew(currentConfig(), filterList)">
      <mat-icon>add</mat-icon>
      Aktuelle Konfiguration speichern
    </button>
  </mat-menu>

  <mat-menu #customFilterActionMenu="matMenu">
    <ng-template matMenuContent let-filterItem="filterItem" let-filterList="filterList">
      <button [disabled]="isLoading" mat-menu-item (click)="applyConfig(filterItem.config)">
        <mat-icon>filter_alt</mat-icon>
        Anwenden
      </button>
      <button [disabled]="isLoading" mat-menu-item (click)="openEdit(filterItem, filterList)">
        <mat-icon>edit</mat-icon>
        Umbenennen
      </button>
      <button [disabled]="isLoading" mat-menu-item (click)="openDelete(filterItem, filterList)">
        <mat-icon>delete</mat-icon>
        Löschen
      </button>
    </ng-template>
  </mat-menu>

  <button
    mat-stroked-button
    [matMenuTriggerFor]="customFilterMenu"
    color="primary"
    title="Eigene Konfigurationen verwalten">
    <mat-icon>filter_alt</mat-icon>
    Eigene Konfigurationen
  </button>
</ng-container>
